import { Handle, Position } from '@xyflow/react'
import { SM_THEME as T } from './stateMachineTheme'

export function EntryNode() {
  return (
    <div style={{
      background: T.entryBg,
      border: `2px solid ${T.entryBorder}`,
      borderRadius: 20,
      padding: '7px 18px',
      color: T.entryText,
      fontFamily: 'var(--m-font)',
      fontSize: 11,
      fontWeight: 'bold',
      letterSpacing: 1,
      whiteSpace: 'nowrap',
      userSelect: 'none',
    }}>
      ENTRY
      <Handle
        type="source"
        position={Position.Right}
        id="out"
        style={{ background: T.handle, width: 10, height: 10 }}
      />
    </div>
  )
}
